/**
 *  komponenta pro štítky pro produkty
 */

import React,{ Fragment, useState } from 'react';
import ModalNotification from '../../../GlobalComponents/ModalNotification';
import Notification from '../../../Library/notification';
import { withApollo, useQuery, useMutation } from 'react-apollo';
import {GET_PROJECTS,DELETE_PROJECTS} from '../Queries/project';
import Loading from '../../../GlobalComponents/Loading';
import Error from '../../../GlobalComponents/Error';
import NoItems from '../../../GlobalComponents/NoItems';
import ProjectLib from '../Library/project';
import Helper from '../../../Library/helper';
import translate from '../../Translations/index';
import AddEditProject from './AddEditProject';
import edit from '../../../Public/Images/edit.svg';

const Projects = (props) => {
        
    const listVariables = {
        offset:0,
        limit:50
    }

	const [selectedProjects,setSelectedProjects]      = useState([]);
    const [showDeleteNotifi,setShowDeleteNotifi]    = useState(false);
    const [showAdd,setShowAdd] 			            = useState(false);
    const [selectedProjectID,setSelectedProjectID]    = useState(0);
    
    const {loading, error:getError, data:projectListData, fetchMore}   = useQuery(GET_PROJECTS,{
        variables:listVariables
    });
 
	const [deleteProject, { data,loading: deleteLoading, error: deleteError }] = useMutation(DELETE_PROJECTS,{	
		update(cache,response) {            
            let project = new ProjectLib(this);
            project.updateAfterDelete(cache, response,listVariables);

            let notify = new Notification();
            notify.setNotification(cache,translate.t("SuccessFullyDeleted"),true,false);
            setShowDeleteNotifi(false);
		},						
		onError(err){
            const helper = new Helper(); 
            let notify = new Notification();
            notify.setNotification(null,helper.getApolloErrorText(err),false,true,props.client);
		}
    });

    /**
     * smazání štítků
     * @param {*} deleteProjects funkce, která posílá data na server
     * @param {*} projectID ID projectu
     */
    
    const initiateDeleteProject = (e,projectID) => {

        var checked = e.target.checked;
        var arr = [...selectedProjects];

        if(!checked){
            for(let i in selectedProjects){
                if(selectedProjects[i] == projectID){
                    arr.splice(i,1);
                }
            }
        }else{
            arr = [projectID,...arr];
        }

        setSelectedProjects(arr);
  
    }

    const delProject = (action) => {

        if(action){

            let projectIDs = selectedProjects.join(",");

            deleteProject({
                variables:{
                    projectIDs: projectIDs
                }
            })
        }
        setShowDeleteNotifi(false);
        //this.setState(INITIAL_STATE);
    }

    const showDelNotifi = () => {

        if(selectedProjects.length > 0){
            setShowDeleteNotifi(true);
        }else{
            let notify = new Notification();
            notify.setNotification(null,translate.t("ItemNotSelected"),false,true,props.client);
        }
    }

    const openCloseModal = (open,driveID) => {
        setSelectedProjectID(driveID);
        setShowAdd(open);
    }

    
    if(getError || deleteError){
        var error = getError ? getError : deleteError;
        const helper = new Helper(); 
        error = "ERROR: " + helper.getApolloErrorText(error)
    }
    return(

        <div id="settings" className="whole-container" >
            
            <div className="row" >
                <div className="col-sm one">
                    <div className="card main">
                        
                        <div className="card-header d-flex align-items-center">
                            {translate.t("ProjectList")}
                            <button className="btn btn-primary btn-thiner ml-auto" onClick={() => openCloseModal(true,0)}>{translate.t("Add")}</button>
                            <button className="btn btn-danger btn-thiner ml-2" onClick={() => showDelNotifi()}>{translate.t("DeleteSelected")}</button>
                        </div>
                        <div className="card-body">

                            {!error ?
                                <div>
                                    <div className="data-list">
                                        
                                        <div className="data-list-item header">
                                            <div className="data-list-item-content">
                                                <div>{translate.t("ItemName")}</div>
                                                <div className="text-center">{translate.t("Type")}</div>
                                                <div className="text-center">{translate.t("Active")}</div>
                                                <div className="text-right static small">{translate.t("Options")}</div>
                                            </div>
                                        </div>
                                        <Fragment>
                                            {projectListData && projectListData.allProjects && projectListData.allProjects.map((item,index) => {

                                                var checked = false;
                                                for(let i in selectedProjects){
                                                    if(selectedProjects[i] == item.projectID)checked = true;
                                                }
                                                                                                                
                                                return (
                                                
                                                    <div key={index} className="data-list-item-content">
                                                        <div>{item.name}</div>
                                                        <div className="text-center">{item.type.name}</div>
                                                        <div className="text-center">{(item.active == 1 ? "Ano" : "Ne" )}</div>
                                                                                                               
                                                        <div className="text-right static small">
                                                            <img onClick={() => openCloseModal(true,item.projectID)} className="edit-icon" src={edit} />
                                                            <input className="delete-checked" type="checkbox" name="deleteProject[]" checked={checked} onChange = {(e) => initiateDeleteProject(e,item.projectID)} />
                                                        </div>
                                                    </div>
                                                            
                                                )
                                                
                                            })} 
                                        </Fragment>
                                    </div>
                                    {!loading ? 
                                        <Fragment>
                                            {projectListData && projectListData.allProjects && projectListData.allProjects.length == 0 ?
                                                <NoItems text={translate.t("NoItemsAddedYet")} />
                                                :  
                                                <Fragment>     
                                                    {!loading && projectListData && projectListData.allProjects.length < projectListData.projectListCount &&                                 
                                                        <div className="text-center p-5">
                                                            <button className="btn btn-primary" onClick={() => fetchMore({
                                                                variables: {...listVariables,
                                                                    offset: projectListData.allProjects.length
                                                                },
                                                                updateQuery: (prev, { fetchMoreResult }) => {
                                                                    if (!fetchMoreResult) return prev;
                                                                    return Object.assign({}, prev, {
                                                                        allProjects: [...prev.allProjects, ...fetchMoreResult.allProjects]
                                                                    });
                                                                }
                                                            })}> {translate.t("LoadMore")} </button>
                                                        </div> 
                                                    }
                                                </Fragment>
                                            }
                                        </Fragment>
                                        :                                    
                                        <Loading />                                    
                                    }
                                    
                                </div>
                                :
                                <Fragment>
                                    {error &&  <Error text={error} />}
                                </Fragment>
                            }
                        </div>
                    </div>
                </div>
            </div> 	
            {showAdd &&
                <AddEditProject openCloseModal={openCloseModal} selectedProjectID={selectedProjectID} listVariables={listVariables} />
            }
            {showDeleteNotifi && <ModalNotification yesNo={true} text={translate.t("RemoveItems?")} callback={delProject} /> }	
        </div>
    );

}

export default withApollo(Projects);